import { render, staticRenderFns } from "./honorCaptureImages.vue?vue&type=template&id=37ede37c"
import script from "./honorCaptureImages.vue?vue&type=script&lang=js"
export * from "./honorCaptureImages.vue?vue&type=script&lang=js"
import style0 from "./honorCaptureImages.vue?vue&type=style&index=0&id=37ede37c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports